import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async atualizarClienteSimplificado(api, parametros) {
    parametros.operacao = 'atualizarClienteSimplificado';

    let retorno = {};

    await api.santriPOST('/rest/cliente', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RCliente/RClienteAtualizarClienteSimplificado.js